import React from 'react';
import './Risk.css';
import { NavLink } from 'react-router-dom';
import PageNavigator from "../../../components/PageNavigator";

function Risk0() {
  return (
    	<div className='Risk'>
    	<PageNavigator group="Risk" />
    		<p className='heading1'>Risk</p>
            <div style={{ display: "flex", paddingLeft: "10vw"}}>
            <ul className='toc-list'>
                <div className='content-group'>
                    <li><NavLink className='Risk-link' to="/corporate_finance/risk/intro">Introduction</NavLink></li>
                    <ul className='toc-list'>
                        <li className='Risk-content'>Comparing Gambles</li>
                        <li className='Risk-content'>Expected Utility</li>
                        <li className='Risk-content'>Certainty Equivalent</li>
                        <li className='TD-content'>Examples</li>
                    </ul>
                </div>
                <div className='content-group'>
                    <li><NavLink className='Risk-link' to="/corporate_finance/risk/risk_aversion">Risk Aversion Measures</NavLink></li>
                    <ul className='toc-list'>
                        <li className='Risk-content'>Concavity</li>
                        <li className='Risk-content'>Unique Preference Ordering</li>
                        <li className='Risk-content'>Risk Aversion Measures</li>
                        <li className='Risk-content'>Absolute vs. Relative Risk Aversion</li>
                        <li className='Risk-content'>Examples</li>
                    </ul>
                </div>
                <div className='content-group'>
                    <li><NavLink className='Risk-link' to="/corporate_finance/risk/diversification">Diversification</NavLink></li>
                    <ul className='toc-list'>
                        <li className='Risk-content'>Independent Gambles</li>
                        <li className='Risk-content'>Risk Aversion and Diversification</li>
                        <li className='Risk-content'>Examples</li>
                    </ul>
                </div>
                <div className='content-group'>
                    <li><NavLink className='Risk-link' to="/corporate_finance/risk/efficient_frontier">Efficient Frontier</NavLink></li>
                    <ul className='toc-list'>
                        <li className='Risk-content'>Portfolio Returns</li>
                        <li className='Risk-content'>Diversification</li>
                        <li className='Risk-content'>Mean and Variance Combinations</li>
                        <li className='Risk-content'>Many Assets</li>
                        <li className='Risk-content'>Risk-Free Asset</li>
                    </ul>
                </div>
                <div className='content-group'>
                    <li><NavLink className='Risk-link' to="/corporate_finance/risk/capm">CAPM</NavLink></li>
                    <ul className='toc-list'>
                        <li className='Risk-content'>CAPM Assumptions</li>
                        <li className='Risk-content'>Optimal Portfolio</li>
                        <li className='Risk-content'>Market Portfolio</li>
                        <li className='Risk-content'>Beta</li>
                        <li className='Risk-content'>Diversifiable vs. Systematic Risk</li>
                        <li className='Risk-content'>Capital Market Line and Security Market Line</li>
                    </ul>
                </div>
                <div className='content-group'>
                    <li><NavLink className='Risk-link' to="/corporate_finance/risk/capm_reg">CAPM and Regression</NavLink></li>
                    <ul className='toc-list'>
                        <li className='Risk-content'>Estimating Beta</li>
                        <li className='Risk-content'>What about Alpha?</li>
                        <li className='Risk-content'>Testing the CAPM</li>
                        <li className='Risk-content'>Limitations</li>
                    </ul>
                </div>
                <div className='content-group'>
                    <li><NavLink className='Risk-link' to="/corporate_finance/risk/factor_models">Factor Models</NavLink></li>
                    <ul className='toc-list'>
                        <li className='Risk-content'>Fama-French Three-Factors</li>
                        <li className='Risk-content'>Constructing Factors</li>
                        <li className='Risk-content'>Interpreting Model Coefficients</li>
                        <li className='Risk-content'>Example</li>
                        <li className='Risk-content'>Other Factors</li>
                    </ul>
                </div>
            </ul>
            </div>
    	<PageNavigator group="Risk"/>
        </div>
  );
}

export default Risk0;